import{__rest as e}from"../_virtual/_tslib.js";import{useRef as n,useState as o,useEffect as t,createElement as i}from"react";import{jsxs as r,Fragment as a,jsx as c}from"react/jsx-runtime";import{ButtonIcon as l}from"@vds-core/button-icons";import{Icon as s}from"@vds-core/icons";import{Body as d}from"@vds-core/typography";import{calculateRem as u,withVDSManager as p,checkIfMobileDevice as m}from"@vds-core/utilities";import{ColorTokens as f}from"@vds-tokens/color";import{LayoutTokens as h}from"@vds-tokens/layout";import y,{keyframes as g,css as v}from"styled-components";import b from"./controls.js";import w from"./leftVolume.js";import x from"./utils.js";import C from"./videoLoader.js";const k="64px",$="44px",I=g`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`,_=g`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`,S=g`
  from {
    opacity: 1;
    scale: 1;
  }
  to {
    opacity: 0;
    scale: 1.33;
  }
`,D=y.div.withConfig({displayName:"VideoWrapper",componentId:"VDS__sc-rdm6c9-0"})`
  box-sizing: border-box;
  background-color: ${f.background.primary.dark.value};
  ${function({showBorder:e}){return e?`\n      box-shadow: 0 0 0 ${u(1)} ${f.palette.gray85.value};\n      `:""}};
  cursor: ${function({fullscreenIdleState:e}){return e?"none":"pointer"}};
  height: 100%;
  ${function({fullscreen:e,ratio:n}){return e?"":`padding-top: ${x(n)}%;`}};
  pointer-events: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  video::-webkit-media-controls {
    display: none !important;
  }
  position: relative;
  width: 100%;
  min-width: ${function({isCompact:e}){return e?"288px":"768px"}};
`,V=y.div.withConfig({displayName:"MobileVideoWrapper",componentId:"VDS__sc-rdm6c9-1"})`
  box-sizing: border-box;
  background-color: ${f.background.primary.dark.value};
  ${function({showBorder:e}){return e?`\n      box-shadow: 0 0 0 ${u(1)} ${f.palette.gray85.value};\n      `:""}};
  ${function({fullscreen:e,ratio:n}){return e?"":`padding-top: ${x(n)}%;`}};
  &::-webkit-scrollbar {
    display: none;
  }
  position: relative;
  width: 100%;
  min-width: 288px;
`,z=y.div.withConfig({displayName:"AbsoluteWrapper",componentId:"VDS__sc-rdm6c9-2"})`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 1;
`,j=y(z).withConfig({displayName:"ErrorWrapper",componentId:"VDS__sc-rdm6c9-3"})`
  background-color: ${f.background.primary.dark.value};
  opacity: 0.8;
  flex-direction: column;
  gap: 14px;
`,N=y.video.withConfig({displayName:"VideoElement",componentId:"VDS__sc-rdm6c9-4"})`
  height: 100%;
  left: 0;
  outline: none;
  top: 0;
  width: 100%;
  &::cue {
    font-family: ${function({isCompact:e,fullscreen:n}){return n||!e?"Verizon-NHG-eDS, Helvetica, Arial, Sans-serif":"Verizon-NHG-eTX, Helvetica, Arial, Sans-serif"}};
    font-weight: 400;
  }
`,P=y.div.withConfig({displayName:"ControlWrapper",componentId:"VDS__sc-rdm6c9-5"})`
  animation: ${function({$display:e}){return e?v`
          animation-delay: 0ms;
          animation-duration: 0.7s;
          animation-fill-mode: forwards;
          animation-name: ${I};
          animation-timing-function: ease;
        `:v`
          animation-delay: 0ms;
          animation-duration: 0.7s;
          animation-fill-mode: backwards;
          animation-name: ${_};
          animation-timing-function: ease;
        `}}
  bottom: 0px;
  display: flex;
  height: 100%;
  left: 0px;
  max-width: 100%;
  opacity: ${function({$display:e}){return e?1:0}};
  position: absolute;
  right: 0px;
  top: 0px;
  width: 100%;
  z-index: 99;
  &:has(:focus-visible) {
    animation: ${v`
      animation-delay: 0ms;
      animation-duration: 0.7s;
      animation-fill-mode: forwards;
      animation-name: ${I};
      animation-timing-function: ease;
    `}
    opacity: 1;
  }
  &:not(:focus-within) {
    opacity: ${function({$display:e}){return e?1:0}};
  }
`,O=y.div.withConfig({displayName:"InnerControlWrapper",componentId:"VDS__sc-rdm6c9-6"})`
  display: flex;
  flex-direction: column;
  justify-content: ${function({isCompact:e}){return e?"space-between":"end"}};
  padding: ${function({isCompact:e}){return e?h.space["4X"].value:h.space["6X"].value}};
  width: 100%;
  &:not(last-child) {
    z-index: 2;
  }
`,T=y.div.withConfig({displayName:"PlayOverlay",componentId:"VDS__sc-rdm6c9-7"})`
  display: flex;
  height: 100%;
  left: 0px;
  position: absolute;
  top: 0px;
  width: 100%;
  z-index: 1;
`,L=y.div.withConfig({displayName:"TopControlWrapper",componentId:"VDS__sc-rdm6c9-8"})`
  bottom: 0px;
  display: flex;
  left: 0px;
  max-width: 100%;
  right: 0px;
  top: 0px;
`,W=y.div.withConfig({displayName:"TopWrapper",componentId:"VDS__sc-rdm6c9-9"})`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  right: 0px;
  top: 0px;
  width: 100%;
  z-index: 100000;
`,E=y.div.withConfig({displayName:"TopOptionsWrapper",componentId:"VDS__sc-rdm6c9-10"})`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  width: 100%;
`,A=y.div.withConfig({displayName:"TopFullScreen",componentId:"VDS__sc-rdm6c9-11"})`
  align-items: center;
  background: ${f.palette.gray20.value};
  border-radius: 24px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 32px;
  justify-content: center;
  transition: opacity 300ms ease-in-out;
  width: 32px;
  z-index: 1;
`,B=y.div.withConfig({displayName:"OuterIconWrapper",componentId:"VDS__sc-rdm6c9-12"})`
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  align-items: center;
  align-self: center;
  opacity: 0;
  animation: ${S} 400ms linear;
  justify-content: center;
  display: flex;
  cursor: pointer;
  height: ${function({isCompact:e}){return e?$:k}};
  width: ${function({isCompact:e}){return e?$:k}};
  border-radius: 96px;
  justify-content: center;
  position: absolute;
  z-index: 999;
`,M=y.div.withConfig({displayName:"StaticOuterIconWrapper",componentId:"VDS__sc-rdm6c9-13"})`
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  align-items: center;
  align-self: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  height: ${function({isCompact:e}){return e?$:k}};
  width: ${function({isCompact:e}){return e?$:k}};
  border-radius: 96px;
  justify-content: center;
  position: absolute;
  z-index: 999;
`,R=y.div.withConfig({displayName:"IconWrapper",componentId:"VDS__sc-rdm6c9-14"})`
  align-items: center;
  border-radius: 96px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: absolute;
  height: ${function({isCompact:e}){return e?$:k}};
  width: ${function({isCompact:e}){return e?$:k}};
  > svg {
    margin-left: ${function({offset:e}){return e}};
  }
  z-index: 2;
  &:focus-visible {
    outline: 1px dashed white;
  }
`,X=y(R).withConfig({displayName:"IndicatorIconWrapper",componentId:"VDS__sc-rdm6c9-15"})`
  animation: ${S} 400ms linear;
  height: ${function({isCompact:e}){return e?$:k}};
  width: ${function({isCompact:e}){return e?$:k}};
`,H=y.div.withConfig({displayName:"IconOverlay",componentId:"VDS__sc-rdm6c9-16"})`
  background-color: ${f.palette.black.value};
  border-radius: 96px;
  opacity: 1;
  z-index: 1;
  height: ${function({isCompact:e}){return e?$:k}};
  width: ${function({isCompact:e}){return e?$:k}};
`,F=y(H).withConfig({displayName:"IndicatorIconOverlay",componentId:"VDS__sc-rdm6c9-17"})`
  background-color:${f.palette.gray44.value};
  opacity:26%
  height: ${function({isCompact:e}){return e?$:k}};
  width: ${function({isCompact:e}){return e?$:k}};
`;var U=p((function(u){var p;const{poster:h,autoPlay:y=!1,muted:g=!1,aspectRatio:v,preload:x="auto",children:k,loop:$=!1,ariaLabel:I="",tracks:_,source:S,key:U,crossOrigin:q,layout:G,viewport:K,errorText:Y,showBorder:J,playsInline:Q=!0,disableRemotePlayback:Z=!1,disablePictureInPicture:ee=!1,vRef:ne}=u,oe=e(u,["poster","autoPlay","muted","aspectRatio","preload","children","loop","ariaLabel","tracks","source","key","crossOrigin","layout","viewport","errorText","showBorder","playsInline","disableRemotePlayback","disablePictureInPicture","vRef"]),te=n(null),ie=n(null),[re,ae]=o(!1),[ce,le]=o(!1),[se,de]=o(!1),[ue,pe]=o(!!y),[me,fe]=o(0),[he,ye]=o(g),[ge,ve]=o(1),[be,we]=o(1),[xe,Ce]=o(!0),[ke,$e]=o(!!_&&!!_.find((function(e){return e.default}))),[Ie,_e]=o(!1),[Se,De]=o(!1),[Ve,ze]=o(!1),je=n(null),Ne=function(...e){return function(n){e.forEach((function(e){"function"==typeof e?e(n):null!=e&&(e.current=n)}))}},Pe=function(){clearTimeout(je.current),De(!1),de(!0)},Oe=function(){Pe(),je.current=window.setTimeout((function(){De(!0),de(!1)}),3e3)},Te=function(){var e;te.current&&(null===(e=document.fullscreenElement)||void 0===e?void 0:e.contains(te.current))?(_e(!0),Oe()):(_e(!1),Pe())};t((function(){const e=te.current;e&&(e.volume=be)}),[be]),t((function(){te.current&&y&&(we(0),ye(!0))}),[y]),t((function(){const e=te.current;e&&(ue?e.play():e.pause())}),[ue]),t((function(){const e=te.current;e&&e.textTracks[0]&&(e.textTracks[0].mode=ke?"showing":"hidden")}),[ke]),t((function(){const e=document.querySelector("[aria-label$='fullscreen']");e&&e.focus();if(te.current)return document.addEventListener("fullscreenchange",Te,!1),function(){document.removeEventListener("fullscreenchange",Te,!1)}}),[Ie]);const Le=function(){const e=te.current;e&&(he?we(ge):(ve(e.volume),we(0)),ye(!he))},We=function(e){if(te.current)if("ArrowUp"===e.key||"ArrowDown"===e.key){e.preventDefault();const n=be||0;if("ArrowUp"===e.key){const e=n+.1<1?n+.1:1;.1===e&&Le(),we(e)}else if("ArrowDown"===e.key){const e=n-.1>0?n-.1:0;n>0&&0===e&&Le(),we(e)}}else(he||0===Number(e.target.value))&&Le(),we(e.target.value)},Ee=function(){ae(!0),le(!1),ze(!1),y&&pe(!0)},Ae=function(){le(!0)},Be=function(){xe&&Ce(!1),ue&&de(!0),pe(!ue),ze(!1),Ie&&Oe()},Me=function(){const e=ie.current;e&&(document.fullscreenElement?document.exitFullscreen():e.requestFullscreen(),_e(!Ie))},Re=function(){te.current&&($||pe(!1),ze(!0))},Xe=function(e){"mouseover"===e.type?de(!0):"mouseleave"===e.type&&(ue||xe)&&de(!1)},He=function(){return _&&_.map((function(e){return c("track",Object.assign({},e),e.src)}))},Fe=m(),Ue=function(e){32===e.keyCode&&Be()},qe="mobile"!==K&&"compact"!==G||Ie?"standard":"compact",Ge="compact"===qe,Ke=h?null==S?void 0:S.src:`${null==S?void 0:S.src}#t=0.001`;return r(a,{children:[!Fe&&r(D,{onMouseOver:function(e){return Xe(e)},onMouseLeave:function(e){return Xe(e)},"aria-label":I,role:"group",ratio:v,ref:ie,showBorder:J,isCompact:Ge,fullscreen:Ie,onMouseMove:function(){Ie&&Oe()},fullscreenIdleState:Se,children:[r(z,{children:[re&&!xe&&!Ve&&r(B,{onClick:Be,"aria-hidden":!0,isCompact:Ge,children:[c(X,{isCompact:Ge,offset:ue?"2px":"0",children:c(s,ue?{size:Ge?"medium":"XLarge",color:f.elements.primary.ondark.value,name:"play-alt-filled"}:{size:Ge?"medium":"XLarge",color:f.elements.primary.ondark.value,name:"pause-alt-filled"})}),c(F,{isCompact:Ge})]},ue.toString()),i(N,Object.assign({},oe,{key:U||(null==S?void 0:S.src),crossOrigin:q||"anonymous",muted:he,onTimeUpdate:function(e){fe(e.target.currentTime)},loop:$,onKeyDown:function(e){return Ue(e)},onClick:Be,ref:Ne(te,ne),poster:h,autoPlay:y,controls:!1,onLoadedData:Ee,preload:x,onEnded:Re,onError:Ae,tabIndex:-1,"aria-hidden":"true",isCompact:Ge,fullscreen:Ie}),S&&c("source",Object.assign({},S)),_&&He(),k)]}),re&&xe&&!y&&c(z,{onClick:Be,"aria-hidden":!0,children:r(M,{isCompact:Ge,children:[c(R,{"aria-label":"play",isCompact:Ge,offset:"2px",children:c(s,{color:f.elements.primary.ondark.value,name:"play-alt-filled",size:Ge?"medium":"XLarge"})}),c(H,{isCompact:Ge})]})}),!re&&!ce&&c(z,{children:c(C,{})}),!re&&ce&&r(j,{children:[c(s,{name:"error",size:"XLarge",color:f.elements.primary.ondark.value}),c(d,{size:"small",color:f.elements.primary.ondark.value,children:Y||"error loading video"})]}),re&&c(P,{tabIndex:-1,role:"presentation",onKeyDown:function(e){return Ue(e)},$display:!xe&&!ue||se,children:r(O,{isCompact:Ge,children:[Ge&&c(L,{children:c(W,{children:r(E,{children:[c(w,{onChangeMuted:Le,onChangeVolume:We,muted:he,volume:be}),c(A,{children:c(l,{focusBorderPosition:"inside",size:"small",kind:"lowContrast",surface:"dark",surfaceType:"media",onClick:Me,ariaLabel:"enter fullscreen",renderIcon:function(e){return c(s,Object.assign({name:"fullscreen-minimize"},e,{ariaHidden:!0,size:"small",color:f.elements.primary.ondark.value}))}})})]})})}),c(b,{volume:{onChangeMuted:Le,onChangeVolume:We,muted:he,volume:be},toggleClosedCaptions:function(){$e(!ke)},showClosedCaptions:ke,playing:ue,fullscreen:Ie,togglePlay:Be,toggleFullscreen:Me,onSeek:function(e){const n=te.current;n&&(fe(e),n.currentTime=e)},elapsedTime:me,duration:(null===(p=null==te?void 0:te.current)||void 0===p?void 0:p.duration)||0,layout:qe}),c(T,{onClick:Be})]})})]}),Fe&&c(V,{ratio:v,ref:ie,showBorder:J,fullscreen:Ie,children:c(z,{children:i(N,Object.assign({},oe,{crossOrigin:"anonymous",muted:he,loop:$,ref:Ne(te,ne),controls:!0,poster:h||void 0,autoPlay:y,onLoadedData:Ee,preload:x,onEnded:Re,key:U||(null==S?void 0:S.src),onError:Ae,isCompact:Ge,fullscreen:Ie,playsInline:Q,disableRemotePlayback:Z,disablePictureInPicture:ee}),S&&c("source",Object.assign({},S,{src:Ke})),_&&He(),k,"Your browser does not support the video tag.")})})]})}));export{U as default};
